import React, { useState, useEffect } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { Tabs, 
  Tab, 
  Box,   
  List, 
  ListItem, 
  ListItemText, 
  ListItemIcon, 
  Checkbox, 
  IconButton, 
  Typography, } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DeleteIcon from '@mui/icons-material/Delete';
import SelectionBox from './ui_components/SelectionBox';

const Legend = (props) => {
  const [legend, setLegend] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [availableTabs, setAvailableTabs] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  useEffect(() => {
    const tabs = [];
    if (props.datalayer) tabs.push('datalayer');
    if (props.traffic) tabs.push('traffic');
    // if (props.customBrandSearch.length > 0) tabs.push('brand');
    setAvailableTabs(tabs);
    
    // Set the tab index to the first available tab
    if (tabs.length > 0 && !tabs.includes(['datalayer', 'traffic', 'brand'][tabIndex])) {
      setTabIndex(0);
    }
  }, [props.datalayer, props.traffic, props.customBrandSearch]);


  const colors = [
    ['rgba(254, 130, 110)', 'rgba(255, 112, 94)', 'rgba(255, 90, 82)', 'rgba(255, 82, 74)', 'rgba(255, 65, 58)', 'rgba(255, 55, 50)'],
    ['rgb(0,124,6)', 'rgb(0,108,6)', 'rgb(0,100,6)', 'rgb(0,84,6)', 'rgb(0,68,6)', 'rgb(0,60,6)'],
    ['rgb(20, 80, 220, .65)', 'rgb(20, 70, 200, .7)', 'rgb(20, 60, 180, .75)', 'rgb(20, 50, 160, .8)', 'rgb(20, 45, 140, .9)', 'rgb(20, 40, 120, .95)']
  ];
// 'motorway': '#00008B',      // DarkBlue
      // 'trunk': '#0000CD',         // MediumBlue
      // 'primary': '#4169E1',       // RoyalBlue
      // 'secondary': '#6495ED',     // SteelBlue
      // 'tertiary': '#87CEFA',

  const traffic_colors = [
      '#B0E2FF', '#87CEFA', '#6495ED', '#4169E1', '#0000CD', '#00008B'
  ];
  
  function formatNumber(value) {
    // Check if the value is a number
    if (typeof value === 'number' || (typeof value === 'string' && !isNaN(value))) {
      // Convert to number to handle string numbers, then to string for formatting
      return Number(value).toLocaleString();
    } else {
      // Return the original value if it's not a number
      return value;
    }
  }

  const changestatehide = () => {
    setLegend(false);
  };

  const handleTabChange = (event, newValue) => {
    if(!isNaN(newValue)) setTabIndex(newValue);
  };


  const val = () => {
    if (props.cluster_type === 1) {
      return 'Family Income Dist.';
    }
    if (props.cluster_type === 0) {
      return 'Population Density';
    }
  };

  const dataLayerTypes = [
    {value: 0, label: 'Population Density'},
    {value: 1, label: 'Family Income'},
    {value: 2, label: 'Recommended Locations'}
  ]

  const trafficLayerTypes = [
    {value: 0, label: 'Roads with Traffic Data'},
    {value: 2, label: 'All Available Roads'}
  ]

  const p = colors[parseInt(props.cluster_type)];

  return (
    <div>
      {/* DATA LAYER LOCATION */}
      <OutsideClickHandler onOutsideClick={() => { props.datalayer_hide() }}>
        <div className={props.datalayer_show ? 'legend-totalval' : 'legend-totalval legend-totalval-hide'}>
          <SelectionBox selectionName={'Data Layer'} selectionValue={props.cluster_type} selectionChecked={props.datalayer} selectionSwitch={props.datalayer_switch} selectionChange={props.layertype} selectionOptions={dataLayerTypes}/>
        </div>

      </OutsideClickHandler>


      <OutsideClickHandler onOutsideClick={() => { props.trafficLayer_hide() }}>
        <div className={props.trafficLayer_show ? 'legend-totalval top-400' : 'legend-totalval legend-totalval-hide top-400'}>
          <SelectionBox selectionName={'Traffic Layer'} selectionValue={props.trafficType} selectionChecked={props.traffic} selectionSwitch={props.trafficLayer_switch} selectionChange={props.trafficLayerType} selectionOptions={trafficLayerTypes}/>

        </div>
      </OutsideClickHandler>
      
      {/* LEGEND LOCATION */}
      <div className='legend-overall'>
        {(props.datalayer) &&<div className="legend-values-total" >
        <div className='font-size-14 color-light-grey margin-custom-50810'>Data Layer</div>
            
            <div className='justify-content mb-10'>
              <div className="font-size-14 color-light-grey legend-eachfilter">{formatNumber(props.min_val)}</div>
            <div style={{ display: 'inline-block' }}>
              {p.map((e) => (
                <div className="legend-values-each" key={e} style={{ background: e }}></div>
              ))}
            </div>
            <div className="font-size-14 color-light-grey legend-eachfilter">{formatNumber(props.max_val)}</div>
          </div>
          </div>}
          {(props.traffic) &&<div className="legend-values-total">
          <div className='font-size-14 color-light-grey margin-custom-50810'>Traffic Layer</div>
            <div className='justify-content mb-10'>
                <div className="font-size-14 color-light-grey legend-eachfilter">Low</div>
                <div style={{ display: 'inline-block' }}>
                  {traffic_colors.map((e) => (
                    <div className="legend-values-each" key={e} style={{ background: e }}></div>
                  ))}
                </div>
                <div className="font-size-14 color-light-grey legend-eachfilter">High</div>
              </div>
        </div>}
      </div>
    </div>
  );
};

export default Legend;
